import { React } from "react";
import { useNavigate } from "react-router-dom";

const ActionCol = ({ row, uriBasePath }) => {
  const navigate = useNavigate();

  return (
    <span className="list-actions">
      <button
        className="list-action-button edit-button"
        onClick={() => navigate(`/${uriBasePath}/edit/${row.id}`)}
      >
        Edit
      </button>
    </span>
  );
};

export default ActionCol;